/* unplugin-vue-components disabled */import { render } from "./CardSkeleton.vue?vue&type=template&id=6db47d4b&scoped=true&ts=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=ts"
export * from "./CardSkeleton.vue?vue&type=script&lang=ts"

import "./CardSkeleton.vue?vue&type=style&index=0&id=6db47d4b&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db47d4b"]])

export default __exports__